<template>
    <BaseCard padding="lg" class="flex flex-col items-center gap-5 text-center">
        <ReflectionIcon kind="self" size="md" />
        <div class="flex flex-col gap-2 max-w-xl">
            <h2 class="display-serif text-valence-stone-900">Start a self reflection</h2>
            <p class="body-small text-valence-stone-500">Check in with yourself — your progress, your challenges, your next step. Your answers shape the coaching you get.</p>
        </div>

        <!-- LAB-988 dark CTA override — see .base-btn-dark in tailwind.css. -->
        <button type="button" class="base-btn-dark base-btn-sm whitespace-nowrap" @click="emit('start')">Launch</button>
    </BaseCard>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import ReflectionIcon from "~vue/pages/reflections/ReflectionIcon.vue";

const emit = defineEmits<{ (event: "start"): void }>();
</script>
